import React, { ReactNode } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
type HelperTextWithCounterProps = BoxProps<'div'> & {
    maxLength: number;
    characterCount: number;
    helperText?: ReactNode;
};
export function HelperTextWithCounter(props: HelperTextWithCounterProps) {
    const { helperText, characterCount, maxLength, ...otherProps } = props;
    return (
        <Box display="flex" justifyContent={helperText ? 'space-between' : 'flex-end'} {...otherProps}>
            <Typography color="inherit" fontSize="inherit" fontWeight="inherit" fontFamily="inherit" component="p">
                {helperText}
            </Typography>
            <Typography color="inherit" fontSize="inherit" fontWeight="inherit" fontFamily="inherit" component="p">
                {characterCount}/{maxLength}
            </Typography>
        </Box>
    );
}
